import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Forward = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M21.7676 11.4561L14.1679 4.20682C13.6937 3.75442 12.912 4.09295 12.912 4.75076V8.00392C12.912 8.27979 12.6859 8.50301 12.412 8.50706C4.51884 8.62374 2.08196 11.5662 2.00001 19.565C1.99893 19.6704 2.14008 19.7074 2.18785 19.6136C3.55587 16.9267 4.78826 15.555 12.411 15.4984C12.685 15.4964 12.912 15.7202 12.912 15.9961V19.2492C12.912 19.9071 13.6937 20.2456 14.1679 19.7932L21.7676 12.5439C22.0775 12.2484 22.0775 11.7516 21.7676 11.4561Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M14.6188 3.66361C13.6918 2.75888 12.164 3.43588 12.164 4.75138V7.76253C8.37132 7.84802 5.6618 8.62797 3.91818 10.5719C2.15347 12.5393 1.54043 15.5241 1.50005 19.5567C1.49154 20.4059 2.64052 20.7936 3.05797 19.9547C3.70541 18.6537 4.2481 17.8233 5.42643 17.2458C6.64366 16.6493 8.60596 16.2915 12.164 16.2496V19.2486C12.164 20.5641 13.6918 21.2411 14.6188 20.3364L22.0458 13.0878C22.6514 12.4968 22.6514 11.5032 22.0458 10.9122L14.6188 3.66361Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
